import { GetStaticProps } from "next";

import ResourcesLayout from "@layouts/ResourcesLayout";
import fetchForm from "@lib/fetchForm";
import { returnStaticProps } from "@lib/returnStaticProps";
import craft from "@pages/api/craft";
import QueryResourcesIndex from "@queries/resources/QueryResourcesIndex.graphql";

export const getStaticProps: GetStaticProps = async () => {
	// Hard code the page's uri
	const uri = "/resources";

	// Fetch the page's data
	const response = await craft(QueryResourcesIndex);

	const {
		pageEntry,
		blogPageEntry,
		resources,
		resourceTypes,
		topics,
		industries,
		primaryNavigation,
		primaryCallToActions,
		globalSet,
	} = response;

	let formData = null;

	let formId = null;

	let formEntry = null;

	// Use the form id specified by the selected form in the pageEntry (if there is one)
	if (!!blogPageEntry && blogPageEntry.form.length) {
		formId = blogPageEntry.form[0].formDetails[0].formId;
		formEntry = blogPageEntry.form[0];
		//console.log('override');
		//console.log(resource.form[0]);
	} else {
		formId = pageEntry?.form ? pageEntry.form[0]?.formDetails[0].formId : null;
		formEntry = pageEntry?.form[0];
		//console.log('default');
		//console.log(pageEntry.form[0]);
	}

	if (formId) {
    formData = await fetchForm({ formId: formId });
	}

	// Return props if entry exists, otherwise check Retour for redirects or 404
	const returnResponse = await returnStaticProps(
		{
			navigation: {
				primaryNavigation,
				primaryCallToActions,
			},
			pageEntry,
			globalSet,
			blogPageEntry,
			resources,
			resourceTypes,
			topics,
			industries,
			formData,
		},
		!pageEntry,
		uri
	);

	return returnResponse;
};

interface IProps {
	pageEntry: any;
	blogPageEntry: any;
	resources: any[];
	resourceTypes: any[];
	topics: any[];
	industries: any[];
	formData: any[];
}

const Page = ({
	pageEntry,
	blogPageEntry,
	resources,
	resourceTypes,
	topics,
	industries,
	formData,
}: IProps): JSX.Element => {
	return <></>;
};

Page.Layout = ResourcesLayout;

export default Page;
